export default __webpack_public_path__ + "static/images/pattern-light-a8b05d58290a2a3c9001d6ac76a5d82e.jpg";